import React, { useContext, useState, useEffect, useCallback } from 'react'
import { ref, update, get, push } from 'firebase/database'
import { MonopolyContext } from '../../contexts/MonopolyContext'
import { useNavigate, useLocation } from 'react-router-dom'
import { CardContent, Box, TextField } from '@mui/material'

const JoinRoom = ({ ButtonElement }) => {
	const location = useLocation()
	let initialRoomCode = ''
	if (location.search.includes('?join=')) {
		initialRoomCode = location.search.replace(/^\?join=(\d+).*$/, '$1')
	}

	const { name, setName, db } = useContext(MonopolyContext),
		[loading, setLoading] = useState(''),
		[roomCode, setRoomCode] = useState(initialRoomCode),
		[roomCodeError, setRoomCodeError] = useState(false)
	const navigate = useNavigate()

	useEffect(() => {
		if (localStorage.getItem('lastRoomCode')) {
			setRoomCode(localStorage.getItem('lastRoomCode'))
		}
	}, [])

	const handleSubmit = useCallback(
		event => {
			if (event) {
				event.preventDefault()
			}

			setLoading(true)
			setRoomCodeError(false)

			if (name) {
				get(ref(db, `lobbies/${roomCode}`)).then(ss => {
					const val = ss.val()
					if (val && val.roomExists) {
						localStorage.setItem('lastRoomCode', roomCode)

						let joinRoomPromise,
							userId,
							joinRoomDataObject = {
								name,
							}
						if (localStorage.getItem('userId')) {
							userId = localStorage.getItem('userId')
							joinRoomPromise = update(
								ref(db, `lobbies/${roomCode}/users/${userId}`),
								joinRoomDataObject
							)
						} else {
							joinRoomPromise = push(
								ref(db, `lobbies/${roomCode}/users`),
								joinRoomDataObject
							)
							userId = joinRoomPromise.key
							if (userId) {
								localStorage.setItem('userId', userId)
							}
						}
						joinRoomPromise.then(_ => {
							navigate(`game/${roomCode}`)
						})
					} else {
						setRoomCodeError("This Room Code doesn't exist")
					}

					setLoading(false)
				})
			}
		},
		[name, roomCode, db, navigate]
	)

	useEffect(() => {
		if (initialRoomCode && name) {
			handleSubmit(false)
		}
	}, [initialRoomCode, name, handleSubmit])

	return (
		<CardContent>
			<Box
				onSubmit={handleSubmit}
				component='form'
				sx={{
					'& .MuiTextField-root': { m: 1, width: '25ch' },
				}}
				autoComplete='off'>
				<TextField
					InputProps={{ style: { letterSpacing: '.1em' } }}
					autoFocus={name ? null : true}
					required
					variant='standard'
					label='Name'
					helperText='Choose your name, visible to everyone in the same
							game'
					onChange={e => {
						let name = e.target.value
						name = name.replace(/\s/, '').toUpperCase().substr(0, 15)
						setName(name)
					}}
					value={name}
					maxLength='15'
					name='name'
					id='name'
				/>
				<TextField
					InputProps={{ style: { letterSpacing: '.3em' } }}
					autoFocus={name || initialRoomCode ? null : true}
					required
					error={!!roomCodeError}
					variant='standard'
					label='Room Code'
					helperText={
						roomCodeError
							? roomCodeError
							: 'Three digit code of the room you want to join'
					}
					onChange={e => {
						roomCodeError && setRoomCodeError(false)
						let roomCode = e.target.value
						roomCode = roomCode.replace(/\D/, '').substr(0, 3)
						setRoomCode(roomCode)
					}}
					value={roomCode}
					type='tel'
					name='room-id'
					maxLength='3'
					pattern='\d+'
				/>
				<Box>
					<ButtonElement
						loading={loading ? true : null}
						variant='contained'
						type='submit'>
						Join Room
					</ButtonElement>
				</Box>
			</Box>
		</CardContent>
	)
}

export default JoinRoom
